export const fabOpeners = {
  offsets: [
    "How many offsets should I buy?",
    "Which portfolio fits my footprint?",
    "How are offsets priced?",
    "Why offsets vs. reductions?"
  ],
  settings: [
    "What sustainability goals should I set?",
    "What historical documents should I upload?",
    "How do I add a teammate?",
    "How is my data used?"
  ],
  upgrade: [
    "What does Navigator add beyond Explorer?",
    "When should I get Aclymate One?",
    "How does Confidence improve?",
    "What's included for my industry?"
  ]
};

export const SURFACE_TO_SCOPE = {
  offsets: "fab-offsets",
  settings: "fab-settings",
  upgrade: "fab-upgrade"
};
